import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.scss';
import { SVGIcon } from '../SVGIcon/SVGIcon';
import { Image } from '../Image/Image';
import logo from '../../images/logo.svg';
import { ROUTES } from '../../lib/constants';
import { Button } from '../Button/Button';
import { NavMenu } from './NavMenu';


export const Header = (): React.JSX.Element => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [icon, setIcon] = useState<'menu' | 'close'>('menu');

  useEffect(() => {
    setIcon(open ? 'close' : 'menu');
  }, [open])

  useEffect(() => {
    /* close menu when location changes */
    setOpen(false);
  }, [location])

  return (
    <header>
      <div className='grid-12 header'>
        <div className='header__left-wrap'>
          <Link className='logo' to='/' aria-label='go to home page'>
            <Image
              src={logo}
              alt='CitySide Fiber logo'
              width='86' 
              height='32' 
              loading='lazy'/>
          </Link>
        </div>

        <div className='header__nav-wrap'>
          <NavMenu open={open} />
        </div>

        <div className='header__right-wrap'>
          <Button
            className='btn--lg-extra-padding'
            href={ROUTES.checkAvailability.path}
            target='_self'
            size='lg'
          >
            Check Availability
          </Button>

          <Button 
            className='btn--lg-extra-padding bg-color--orange'
            path={ROUTES.login.path}  
            target='_self'
            size='lg'
          >
            Log In
          </Button>

          <button aria-label={open ? 'close menu' : 'open menu'} onClick={() => setOpen(!open)}>
            <SVGIcon 
              id={icon} 
              color='marina-blue'
            />
          </button>
        </div>
      </div>
    </header>
  )
};